app.KioskStatusList = app.HistoryAwareCollection.extend({
  model: app.KioskStatus,

  comparator(model) {
    return model.get('prefix');
  },

  url() {
    throw new Error('please provide a url in the initializer');
  },
});
